import { localhostApi } from './localhost-api';
import { isThisLocalhost } from '../framework/utils';
import { ApiClientBase } from '../framework/services/api-client-base';
import { PresenterAccountService } from './account';

class ApiClientClass extends ApiClientBase {
    constructor() {
        super();

        this.host = isThisLocalhost() ? localhostApi : window.location.origin;
        this.host = this.host + '/api';
    }

    protected acquireToken(): Promise<string> {
        return PresenterAccountService.getBearerToken()
        .catch(err => {
            if(err === 401) {
                PresenterAccountService.involuntaryLogOut();
            }
            return Promise.resolve('');
        });
    }
}

export const ApiClient = new ApiClientClass();